import { parse } from "util/parsers";
import { when } from "util/support";
import type { WithOnboardingStep, WithFieldsComments } from "features/onboarding/types";

export const useFieldsComments = () => {
    const parseFieldsComments = ({ fieldsComments }: WithFieldsComments) => (
        parse(String(fieldsComments))
    );

    const serializeFieldsComments = ({ fieldsComments }: Partial<WithFieldsComments>) => when(
        fieldsComments,
        JSON.stringify(fieldsComments),
        null
    );

    const withFieldsComments = <TStep extends object>(stepData: WithOnboardingStep<TStep>): WithOnboardingStep<TStep> => ({
        ...stepData,
        fieldsComments: parseFieldsComments(stepData)
    });

    return {
        withFieldsComments,
        parseFieldsComments,
        serializeFieldsComments
    };
};

export default useFieldsComments;
